<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <form id="UpdateCourse" @submit.prevent="updateCourse" >
        <CCardHeader>
            <CCol col="6" style="font-size: 25px;">تعديل الدورة</CCol>
        </CCardHeader>
        <CCardBody>
            <CRow>
              <CCol col='4'>
                <div class='form-group'>
                    <label for='categories'>
                      الأقسام
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required'
                        v-model='selectedCategory'
                        id='categories'
                        @select="onCategoriesChange($event)"
                        :options='categories'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر القسم المناسب '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <!-- <div v-if(errors.category_id) class="invalid-feedback">
                        {{errors.category_id}}
                      </div> -->
                    </div>
                  </div>
              </CCol>
              <CCol col='4'>
                <div class='form-group'>
                    <label for='subCategories'>
                      الأقسام الفرعية
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required'
                        v-model='selectedSubCategory'
                        @select="onSubCategoriesChange($event)"
                        id='subCategories'
                        :options='subCategories'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر القسم الفرعي  '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <!-- <div v-if(errors.sub_category_id) class="invalid-feedback">
                        {{errors.sub_category_id}}
                      </div> -->
                    </div>
                  </div>
              </CCol>
            </CRow>
            <hr/>
            <CRow>
              <CCol col="6">
                <CInput label="English Name"
                  id="name"
                  v-model="course.name"
                  class="required"
                  placeholder=" أدخل إسم الدورة بالانجليزية"
                  :invalidFeedback="errors.name"
                  required
                />
              </CCol>
              <CCol col="6">
                <CInput label="الإسم"
                  id="name_ar"
                  v-model="course.name_ar"
                  class="required"
                  placeholder="أدخل إسم الدورة بالعربي"
                  :invalidFeedback="errors.name_ar"
                  required='required'
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6">
                <CInput label="تكلفة"
                  id="cost"
                  type="number"
                  v-model="cost"
                  min=0
                  class="required"
                  placeholder=" ادخل تكلفة الدورة"
                  :invalidFeedback="errors.cost"
                  required='required'
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6">
                <CInput label="عدد ساعات"
                  id="total_hours"
                  type="number"
                  min=1
                  v-model="course.total_hours"
                  class="required"
                  placeholder="أدخل عدد ساعات الدورة"
                  :invalidFeedback="errors.total_hours"
                 required='required'
                />
              </CCol>
            </CRow>
              <CRow>
               <CCol col="6">
                <CInput label="عدد أيام الدورة المتاحة "
                  id="end_date"
                  type="number"
                  v-model="course.number_of_days"
                  class="required"
                  min=1
                  placeholder="عدد أيام الدورة المتاحة"
                  :invalidFeedback="errors.end_date"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6">
                <div class='form-group'>
                    <label for='instructors'>
                      المدرب
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required instr'
                        v-model='selectedInstructor'
                        id='instructors'
                        :options='instructors'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر المدرب المناسب '
                        label='full_name'
                        track-by='full_name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <!-- <div v-if(errors.instructor_id) class="invalid-feedback">
                        {{errors.instructor_id}}
                      </div> -->
                    </div>
                  </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="4">
                <div class='form-group'>
                  <label for='old-image'>
                    الصورة القديمة
                    <span class='star'>*</span>
                  </label>
                  <img :src="course.image_full_path" height="200px" width="200px"/>
                </div>
              </CCol>
              <CCol col="8">
                <div class='form-group'>
                  <label for='image' class="required">
                    تغيير الصورة
                    <span class='star'>*</span>
                  </label>
                  <input type="file" class="form-control"
                    id="image"
                    v-on:change="onFileChange"
                  >
                  <!-- <div v-if(errors.image) class="invalid-feedback">
                    {{errors.image}}
                  </div> -->
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="2">
                <label>محاور الدورة بالإنجليزية </label>
              </CCol>
              <CCol col="10">
                 <client-only>
                  <VueEditor id="desc" v-model='course.description' :invalidFeedback="errors.description" />
                   </client-only>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="2">
                <label>محاور الدورة بالعربي </label>
              </CCol>
              <CCol col="10">
                 <client-only>
                  <VueEditor id="desc" v-model='course.description_ar' :invalidFeedback="errors.description_ar" />
                   </client-only>
              </CCol>
            </CRow>
            <hr/>
            <hr/>
            <CRow>
              <CCol col="12">
                <h4>الوحدات</h4>
                <button class="btn btn-primary" type="button" @click="addSection">إضافة وحدة</button>
              </CCol>
            </CRow>
            <CRow>
              <table class="table mt-2">
                <thead>
                  <tr>
                    <th>#</th>
                  <th>إسم الوحدة بالعربي</th>
                  <th>إسم الوحدة بالانجليزية</th>
                  <th>حذف وحدة</th>
                  <th>إصافة درس</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(section, index) in sections"
                    :key="index"
                  >
                  <td>{{section.id}}</td>
                    <td>
                      <input
                        id="name"
                        v-model="section.name_ar"
                        class="required form-control"
                        placeholder="أدخل إسم الوحدة بالعربي"
                        required='required'
                      />
                    </td>
                    <td>
                      <input
                        id="name"
                        v-model="section.name"
                        placeholder=" أدخل إسم الوحدة بالانجليزية"
                        class="required form-control"
                        required
                      />
                    </td>
                    <td>
                      <CButton
                        class="removeItem"
                        type="button"
                        size="xs"
                        color="danger"
                        @click="removeSection(index,section.id)"
                      >
                        حذف
                      </CButton>
                    </td>
                    <td>
                      <CButton
                        class="newItem"
                        type="button"
                        size="xs"
                        color="warning"
                        @click="addLesson(index)"
                      >
                        إضافة درس
                      </CButton>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CRow>
            <CRow>
              <CCol col="12">
                <h3>الدروس</h3>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="12">
                <table class="table">
                <thead>
                  <tr>
                  <th>رقم الوحدة </th>
                  <th>عنوان الدرس بالعربي</th>
                  <th>عنوان الدرس بالإنجليزية</th>
                  <th>الفديو القديم</th>
                   <th>الفيديو بصيغة (mp4)</th>
                  <th>حاله العرض</th>
                  <th>حذف درس</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(lesson, index) in lessons"
                    :key="index"
                  >
                    <td>{{lesson.section_id}}</td>
                    <td><input v-model="lesson.title_ar" class="form-control" required></td>
                    <td><input v-model="lesson.title" class="form-control" required></td>
                    <td><a v-bind:href="lesson.video_full_path" id="video-container" target="_blank">الفيديو القديم</a></td>
                      <vue-dropzone  required ref="myUniqueID"   :id="index" :use-custom-slot="true"   :options="dropzoneOptions" @vdropzone-file-added="getFileCount"  @vdropzone-success="Success"  @vdropzone-sending="sendingEvent" @vdropzone-removed-file='removed'   @vdropzone-canceled='canceled'   @vdropzone-error="failed" >
                         <!-- eslint-disable-next-line vue/valid-v-model -->
                        <span class='dropzone-custom-content' :data-value='index' :id="index">تحميل </span>
                      </vue-dropzone>

                      <td class="text-center">
                        <input type="checkbox" class="form-check-input" id="lesson-free" v-model="lesson.free" :checked="lesson.free" @change="changeLessonFree(lesson)">
                        <label class="form-check-label" for="lesson-free">مجاني</label>
                      </td>
                    <td v-if="lesson.id">
                      <CButton
                        class="removeItem"
                        type="button"
                        size="xs"
                        color="danger"
                        @click="removeoldLesson(lesson.id,index)"
                      >
                        حذف
                      </CButton>
                    </td>
                    <td v-else>
                      <CButton
                        class="removeItem"
                        type="button"
                        size="xs"
                        color="danger"
                        @click="removenewLesson(index)"
                      >
                        حذف
                      </CButton>
                    </td>
                  </tr>
                </tbody>
                </table>
              </CCol>
            </CRow>
            <CRow>
               <CCol col="12">
                <CTextarea
                  label='تقييم الدورة'
                  placeholder='ادخل رابط التقييم'
                  horizontal
                  rows='4'
                  v-model='course.review'
                  :invalidFeedback="errors.review"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton @click="validation()" type="submit" size="xs" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="reset" size="xs" color="danger"><CIcon name="cil-ban"/> مسح </CButton>
          </CCardFooter>
          </form>
        </CCard>
      </CCol>
    </CRow>
</template>

<script>
import $ from 'jquery'
import swal from 'sweetalert'
import { VueEditor } from 'vue2-editor'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  name: 'UpdateCourse',
  components: {
    VueEditor,
    vueDropzone: vue2Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        url: this.$hostUrl + 'medialibrary/upload',
        thumbnailWidth: 150,
        maxFilesize: 500,
        addRemoveLinks: true,
        chunking: true,
        chunkSize: 2000000,
        autoProcessQueue: true,
        timeout: 200000,
        dictRemoveFile: 'Remove',
        headers: { Authorization: 'Bearer ' + localStorage.token },
        dictDefaultMessage: '<i class="fas fa-cloud-upload-alt"></i>تحميل الفيديو'
      },
      course: {},
      cost: 0,
      subCategories: [],
      selectedSubCategory: '',
      categories: [],
      selectedCategory: '',
      instructors: [],
      selectedInstructor: '',
      image: '',
      sections: [],
      lessons: [],
      newlessons: [],
      errors: [],
      uploadPercentage: 0,
      success_videos: [],
      old_videos: [],
      all_videos: [],
      allfiles: 0
    }
  },
  watch: {
    sections: function (val) {
      this.sections = val
    }
  },
  created () {
    const categories = []
    const current = this
    this.$http
      .get(`${this.$hostUrl}categories`)
      .then((response) => {
        $.each(response.data.data, function (key, value) {
          categories.push({ id: value.id, name: value.name_ar })
        })
        this.categories = categories
      })
    const subCategories = []
    this.$http
      .get(`${this.$hostUrl}sub-categories`)
      .then((response) => {
        $.each(response.data.data, function (key, value) {
          subCategories.push({ id: value.id, name: value.name_ar })
        })
        this.subCategories = subCategories
      })
    const instructors = []
    this.$http
      .get(`${this.$hostUrl}instructors`)
      .then((response) => {
        $.each(response.data.data, function (key, value) {
          instructors.push({ id: value.id, full_name: value.full_name_ar })
        })
        this.instructors = instructors
      })
    this.$http
      .get(`${this.$hostUrl}courses/${this.$route.params.id}/edit`)
      .then((response) => {
        this.cost = response.data.data.cost
        this.course = response.data.data.course
        this.selectedInstructor = {
          id: this.course.instructor.id,
          full_name: this.course.instructor.full_name_ar
        }
        this.selectedSubCategory = {
          id: this.course.sub_category.id,
          name: this.course.sub_category.name_ar
        }
        this.selectedCategory = {
          id: this.course.sub_category.category.id,
          name: this.course.sub_category.category.name_ar
        }
        $.each(this.course.sections, function (key, value) {
          current.sections.push({
            id: value.id,
            name: value.name,
            name_ar: value.name_ar
          })
          $.each(value.lessons, function (key, lesson) {
            current.old_videos.push(lesson.video)
            current.lessons.push({
              id: lesson.id,
              title: lesson.title,
              title_ar: lesson.title_ar,
              video_full_path: lesson.video_full_path,
              video: lesson.video,
              section_id: value.id,
              section_name: value.name_ar,
              free: lesson.free,
              video_index: 'null'
            })
          })
        })
      })
  },
  methods: {
    // dropzonevideo
    sendingEvent (file, xhr, formData) {
      xhr.ontimeout = () => {
      /* Execute on case of timeout only */
        swal('Server Timeout')
      }
      const $preview = $(file.previewElement)
      const nearestele = $preview.parent().find('.dz-message').find('.dropzone-custom-content').data('value')
      formData.append('lesson_index', nearestele)
      formData.append('dzFilename', file.name)
      formData.append('dzTotalChunkCount', file.upload.totalChunkCount)
      formData.append('dzChunkIndex', file.upload.chunkIndex)
      formData.append('dzUuid', file.upload.uuid)
      if (typeof nearestele !== 'undefined') {
        formData.append('lesson_index', nearestele)
      }
    },
    getFileCount () {
      this.allfiles++
      console.log('videos count', this.allfiles)
    },
    canceled () {
      this.allfiles--
      console.log('videos count', this.allfiles)
    },
    // onVideoChange (e) {
    //   const video = e.target.files[0]
    //   const path = e.path
    //   // this.lessons[path[0].id].video = video
    //   this.videos.push(video)
    //   this.lessons[path[0].id].video_index = this.videos.length - 1
    //   console.log(this.lessons)
    // },
    onFileChange (e) {
      const _URL = window.URL || window.webkitURL
      this.image = e.target.files[0]
      let file = ''
      if ((file = e.target.files[0])) {
        const img = new Image()
        img.onerror = function () {
          swal('صيغة الملف غير مدعومة: ' + file.type)
          this.image = null
        }
        img.src = _URL.createObjectURL(file)
      }
    },
    onCategoriesChange ($event) {
      const subCategories = []
      this.$http
        .get(
            `${this.$hostUrl}categories/${$event.id}/sub-categories`
        )
        .then((response) => {
          $.each(response.data.data, function (key, value) {
            subCategories.push({ id: value.id, name: value.name_ar })
          })
          this.subCategories = subCategories
        })
    },
    addSection () {
      this.sections.push({
        id: null,
        name: null
      })
    },
    addLesson (index) {
      const section = this.sections[index]
      this.lessons.push({
        section_id: section.id,
        section_name: section.name_ar,
        id: null,
        name: null,
        video: null,
        free: null,
        video_index: null
      })
    },
    Success (file, response) {
      const chunckresponse = JSON.parse(file.xhr.response)
      console.log(chunckresponse)
      // Add media_id to the corresponding lesson
      if (chunckresponse && typeof chunckresponse.lesson_index !== 'undefined' && typeof chunckresponse.media_id !== 'undefined') {
        this.lessons[chunckresponse.lesson_index].media_id = chunckresponse.media_id
      }
      if (chunckresponse.message) {
        swal(chunckresponse.message)
      }
    },
    failed (file, message, xhr) {
      console.log('failed', xhr)
      swal('فشل التحميل')
      $('.dz-error-message span').text('خطأ بالشبكة')
    },
    removed (file, error, xhr) {
    },
    removeSection (index, sectionid) {
      const section = this.sections[index]
      if (sectionid) {
        this.$http
          .delete(
              `${this.$hostUrl}sections/${sectionid}`,
              { _method: 'delete' }
          ).then((response) => {
            swal({ title: response.data.message, buttons: 'تم' })
            this.sections.splice(index, 1)
          })
          .catch(function (error) {
            if (Object.prototype.hasOwnProperty.call(error, 'response')) {
              if (error.response.status === 422) {
                swal('لا يمكن حذف وحدة تحتوي علي دروس')
              }
            }
          })
      } else {
        let remove = 1
        $.each(this.lessons, function (key, value) {
          if (value.section_id === section.id) {
            remove = 0
          }
        })
        if (remove) {
          this.sections.splice(index, 1)
        } else {
          swal('لايمكن حذف وحده تحتوي على دروس')
        }
      }
    },
    removeoldLesson (lessonid, index) {
      this.$http
        .delete(
              `${this.$hostUrl}lessons/${lessonid}`,
              { _method: 'delete' }
        ).then((response) => {
          swal({ title: response.data.message, buttons: 'تم' })
          this.lessons.splice(index, 1)
          this.lessons.videos(index, 1)
        }).catch(function (error) {
          if (Object.prototype.hasOwnProperty.call(error, 'response')) {
            if (error.response.status === 422) {
              swal('لا يمكن حذف الدرس حيث يتم الإستماع اليه حاليا')
            }
          }
        })
    },
    removenewLesson (index) {
      this.lessons.splice(index, 1)
      this.videos.splice(index, 1)
    },
    changeLessonFree (event) {
      console.log(event)
      event.free = Number((event.free ? 1 : 0))
    },
    async updateCourse (e) {
      e.preventDefault()
      const formData = new FormData()
      if (this.selectedInstructor) {
        formData.append('instructor_id', this.selectedInstructor.id)
      } else {
        this.errors.push('instructor_id')
        this.errors.instructor_id = 'instructor field is required'
        $('.instr .multiselect__tags').addClass('redborder')
        swal('يرجى تحديد مدرب للدورة')
        return 0
      }
      if (this.selectedSubCategory) {
        formData.append('sub_category_id', this.selectedSubCategory.id)
      } else {
        this.errors.push('sub_category_id')
        this.errors.subcategory_id = 'subcategory id field is required'
        swal('يرجى تحديد قسم فرعي للدوره')
        $(' .sub .multiselect__tags').addClass('redborder')
      }
      if (/^\d+$/.test(this.course.name)) {
        swal('اسم الدورة يجب ان يحتوي على حروف')
        $('#name').addClass('redborder')
        return 0
      }
      if (/^\d+$/.test(this.course.name_ar)) {
        swal('اسم الدورة يجب ان يحتوي على حروف')
        $('#name_ar').addClass('redborder')
        return 0
      }
      formData.append('_method', 'PUT')
      formData.append('name', this.course.name)
      formData.append('name_ar', this.course.name_ar)
      if (this.cost > 0) {
        formData.append('cost', this.cost)
      } else {
        swal(' سعر الدورة يجب ان يكون اكبر من صفر ')
        $('#cost').addClass('redborder')
        return 0
      }
      formData.append('total_hours', this.course.total_hours)
      formData.append('number_of_days', this.course.number_of_days)
      if (this.course.lesson_number) {
        formData.append('lesson_number', this.course.lesson_number)
      }
      if (this.image) {
        formData.append('image', this.image)
      }
      if (this.course.description_ar) {
        formData.append('description_ar', this.course.description_ar)
      }
      if (this.course.description) {
        formData.append('description', this.course.description)
      }
      if (this.sections.length) {
        formData.append('sections', JSON.stringify(this.sections))
      }
      if (this.lessons.length) {
        formData.append('lessons', JSON.stringify(this.lessons))
      }
      this.all_videos = (this.old_videos.concat(this.success_videos))
      // console.log(this.concatedarr)
      const videoCount = this.all_videos.length
      for (let index = 0; index < videoCount; index++) {
        formData.append('videos[]', this.all_videos[index])
      }
      if (this.course.review) {
        formData.append('review', this.course.review)
      }
      this.errors = await this.postRequest(formData, `${this.$hostUrl}courses/${this.$route.params.id}`, '/courses')
    },
    validation () {
      const Allinput = document.querySelectorAll('form input')
      Allinput.forEach((input) => {
        const select = input.hasAttribute('autocomplete')
        // eslint-disable-next-line valid-typeof
        const attr = input.hasAttribute('data-video')
        if (input.value === '' && input.type !== 'file' && input.type !== 'checkbox' && attr !== true && !select) {
          input.oninput = function () {
            input.classList.remove('redborder')
          }
          input.classList.add('redborder')
          swal(' لا يمكن ترك الحقل فارغا')
          return 0
        }
      })
    }
  }
}

</script>
<style >
.redborder{
  border-color:red !important
}
.vue-dropzone>.dz-preview .dz-remove{
  bottom:0 !important;
  padding: 5px !important;
}

</style>
